import httpService from '@/services/httpService'

export const types = {
  ADD_GROUPS: 'authorization/ADD_GROUPS',
  ADD_PERMISSIONS: 'authorization/ADD_PERMISSIONS'
}

const state = {
  groups: [],
  permissions: []
}

const mutations = {
  [types.ADD_GROUPS]: function (state, groups) {
    state.groups = groups
  },
  [types.ADD_PERMISSIONS]: function (state, permissions) {
    state.permissions = permissions
  }
}

const actions = {
  getPermissionsData: async function ({ commit }, { clientId }) {
    const response = await httpService.get(`/authorization/${clientId}/permissions`)
    if (!response?.data?.permissions) {
      commit(types.ADD_PERMISSIONS, [])
      return []
    }
    commit(types.ADD_PERMISSIONS, response.data.permissions)
    return response.data.permissions
  },
  updatePermission: function ({ commit }, { clientId, permission }) {
    permission = JSON.stringify(permission)
    return httpService.patch(`/authorization/${clientId}/permissions`, { form: permission },
      { successMessage: 'Permission successfully updated', raiseError: true })
  },
  getGroupData: async function ({ commit }, { clientId }) {
    const response = await httpService.get(`/authorization/${clientId}/groups`)
    if (!response?.data?.groups) {
      commit(types.ADD_GROUPS, [])
      return []
    }
    commit(types.ADD_GROUPS, response.data.groups)
    return response.data.groups
  },
  createGroup: function ({ commit }, { clientId, group }) {
    group = JSON.stringify(group)
    return httpService.post(`/authorization/${clientId}/groups`, { form: group },
      { successMessage: 'Group successfully created', raiseError: true })
  },
  deleteGroup: function ({ commit }, { clientId, id }) {
    const config = {
      params: {
        id
      },
      successMessage: 'Group successfully deleted',
      raiseError: true,
    }
    return httpService.delete(`/authorization/${clientId}/groups`, config)
  },
  updateGroup: function ({ commit }, { clientId, group }) {
    group = JSON.stringify(group)
    return httpService.patch(`/authorization/${clientId}/groups`, { form: group },
      { successMessage: 'Group successfully updated', raiseError: true })
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
